import React, {useState} from "react";
import AddGroup from "../../components/Modal/AddGroup";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/ProtectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import GroupsTable from "./groupsTable";
import "./group.scss";

const GroupComponent = () => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <SafeView>
      <ProtectedContent perms={["view_group"]} showFallback>
        <>
          {modalStatus && (
            <AddGroup open={modalStatus} onClose={() => setModalStatus(false)} />
          )}
          <ProtectedContent perms={["add_group"]}>
            <CommonHeader
              content={"Add Group"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_group"}
            />
          </ProtectedContent>
          <div className="table-container">
            <GroupsTable />
          </div>
        </>
      </ProtectedContent>
    </SafeView>
  );
};

const Group = () => {
  return (
    <PageURLContextProvider>
      <GroupComponent />
    </PageURLContextProvider>
  );
};

export default Group;
